import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function CarouselIcon(props) {
  const { height, width, iconColor } = props;

  return (
    <svg viewBox="0 0 35 3" width={width} height={height} version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-636 -4134)" fill={iconColor} fillRule="nonzero">
          <rect id="Rectangle-5-Copy-3" x="636" y="4134" width="35" height="3" />
        </g>
      </g>
    </svg>
  );
}

CarouselIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

CarouselIcon.defaultProps = {
  height: 3,
  width: 35,
  iconColor: colors.colorGrey04
};

export default CarouselIcon;
